import * as is from 'Services/Misc/is';
import { getMediaHandler } from './MediaFactory';
import { controlSurveyPending } from 'Services/Misc/survey';

export default class MediaManager {
  async onUpdate(nextState, prevState, changes) {
    let configurePromise;
    this.state = nextState;

    if(changes.media.element) {
      this.videoEl = nextState.media.element;
    }

    if(changes.display.container) {
      this.container = nextState.display.container;
    }

    if(changes.configuration.Media) {
      const mediaHandler = await getMediaHandler(nextState.configuration),
            container    = this.container.querySelector('#aa-video-ad-unit');

      if(mediaHandler && container) {
        this.selectedMedia = mediaHandler;
        configurePromise = 
          this
            .selectedMedia
            .configure(this.videoEl, container, nextState.host)
            .then(() => {
              if(this.canStart(this.state)) {
                this.selectedMedia.start();
              }
            });
      } else {
        throw new Error('No playable media found');
      }

      if(this.adStarted(nextState)) {
        this.selectedMedia.start();
      }

      return configurePromise;
    }

    if(this.adResumed(changes, nextState)) {
      this.selectedMedia.play();
    }

    if(this.adPaused(changes, nextState)) {
      this.selectedMedia.pause();
    }

    if(this.canStart(nextState)) {
      this.selectedMedia.start();
    }

    if(this.selectedMedia && changes.media.volume) {
      this.selectedMedia.setVolume(nextState.media.volume);
    }

    if(this.adSizeChanged(changes, nextState)) {
      this.selectedMedia.resize(nextState.display.width, nextState.display.height, nextState.display.viewMode);
    }
  }

  canStart(nextState) {
    return (
      this.mediaExists          &&
      this.adStarted(nextState) &&
      this.selectedMedia.ready  &&
      !nextState.media.started  &&
      !controlSurveyPending(nextState.configuration, nextState.measurement)
    );
  }

  adStarted({ host }) {
    return host.received.indexOf('startAd') > -1;
  }

  adPaused(changes, state) {
    return this.mediaExists && changes.media.paused && state.media.paused;
  }

  adResumed(changes, state) {
    return this.mediaExists && changes.media.paused && !state.media.paused;
  }

  adSizeChanged(changes, state) {
    return this.mediaExists && state.display && changes.display && (changes.display.width || changes.display.height || changes.display.viewMode);
  }

  get mediaExists() {
    return !!this.selectedMedia;
  }
}


// WEBPACK FOOTER //
// ./src/Media/MediaManager.js